



































































































































































































import { Component, Ref } from 'vue-property-decorator'
import { getResultList } from '@/request/apis/AdvancedRequest'
import RouterHelper from '@/mixins/RouterHelper.vue'
import ModuleIntroduction from '@/components/common/ModuleIntroduction.vue'
import ModuleWrapper from '@/components/common/ModuleWrapper.vue'
import Gallery from '@/components/common/Gallery.vue'
import { getCirroUrl } from '@/request/apis/common'
import StickyButton from '@/components/common/StickyButton.vue'
import ResultWrapper from '@/components/common/ResultWrapper.vue'
import UpdateButton from '@/components/common/UpdateButton.vue'

@Component({
  components: {
    Gallery,
    StickyButton,
    UpdateButton,
    ModuleWrapper,
    ResultWrapper,
    ModuleIntroduction
  },
  beforeRouteUpdate (to, from, next) {
    next()
    // @ts-ignore
    this.getResult()
  }
})

export default class AdvancedDownstreamAnalysisResult extends RouterHelper {
  @Ref('cluster-iframe-wrapper') clusterIframeWrapper!: HTMLElement
  @Ref('diff-iframe-wrapper') diffIframeWrapper!: HTMLElement
  @Ref('cell-iframe-wrapper') cellIframeWrapper!: HTMLElement
  @Ref('trajectory-iframe-wrapper') trajectoryIframeWrapper!: HTMLElement
  @Ref('cluster-iframe') clusterIframe!: HTMLIFrameElement
  @Ref('diff-iframe') diffIframe!: HTMLIFrameElement
  @Ref('cell-iframe') cellIframe!: HTMLIFrameElement
  @Ref('trajectory-iframe') trajectoryIframe!: HTMLIFrameElement

  private activeName: string = ''
  private dataDownloadUrl: string = ''
  private imgDownloadUrl: string = ''
  private QCUrl: string = ''
  private highlyUrl: string = ''
  private clusteringUrl: string = ''
  private cellTypeUrl: string = ''
  private trajectoryUrl: string = ''
  private thumbList: any[] = []
  private clusterCirroUrl: string = ''
  private diffCirroUrl: string = ''
  private cellCirroUrl: string = ''
  private trajectoryCirroUrl: string = ''
  private currentImage: string = ''
  // 避免等待返回过程中反复请求cirro接口
  private hasRequest: { [key: string]: boolean } = { 'Clustering': false, 'DifferentialExpression': false, 'CellTypeAnnotation': false, 'TrajectoryAnalysis': false }

  get id () {
    return this.$route.params.id
  }

  mounted () {
    this.getResult()
  }

  /**
   * 获取结果数据并显示
   */
  private async getResult () {
    const result = await getResultList(null, this.id).start()
    this.dataDownloadUrl = result.data_download
    this.imgDownloadUrl = result.images_download
    this.QCUrl = result.QC
    this.highlyUrl = result.Highly
    this.clusteringUrl = result.Clustering
    this.cellTypeUrl = result.CellType
    this.trajectoryUrl = result.Trajectory
    this.thumbList = result.Differential.images
    this.currentImage = this.thumbList[0]
    // 获取第一个有实际内容的类别 作为activeName
    for (let item in result) {
      if (result.hasOwnProperty(item) && result[item].length) {
        this.activeName = item
        break
      }
    }
  }

  /**
   * 获取各个类型的cirro
   */
  private async getCirro (type: string) {
    try {
      let getCirroRequest: any
      switch (type) {
        case 'Clustering':
          getCirroRequest = getCirroUrl(this.clusterIframeWrapper, { jobId: this.id, type: type })
          this.clusterCirroUrl = await getCirroRequest.start()
          break
        case 'DifferentialExpression':
          getCirroRequest = getCirroUrl(this.diffIframeWrapper, { jobId: this.id, type: type })
          this.diffCirroUrl = await getCirroRequest.start()
          break
        case 'CellTypeAnnotation':
          getCirroRequest = getCirroUrl(this.cellIframeWrapper, { jobId: this.id, type: type })
          this.cellCirroUrl = await getCirroRequest.start()
          break
        case 'TrajectoryAnalysis':
          getCirroRequest = getCirroUrl(this.trajectoryIframeWrapper, { jobId: this.id, type: type })
          this.trajectoryCirroUrl = await getCirroRequest.start()
          break
      }
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * 切换tab时获取cirro软件的地址
   */
  private async clickHandler () {
    try {
      if (!this.hasRequest[this.activeName]) {
        this.hasRequest[this.activeName] = true
        await this.getCirro(this.activeName)
      }
      switch (this.activeName) {
        case 'Clustering':
          this.clusterIframe.src = this.clusterCirroUrl // 重新加载，否则tab切换时iframe显示空白
          break
        case 'DifferentialExpression':
          this.diffIframe.src = this.diffCirroUrl
          break
        case 'CellTypeAnnotation':
          this.cellIframe.src = this.cellCirroUrl
          break
        case 'TrajectoryAnalysis':
          this.trajectoryIframe.src = this.trajectoryCirroUrl
          break
      }
    } catch (e) {
      console.log(e)
    }
  }
}
